import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterKey',
    standalone: false
})
export class FilterKeyPipe implements PipeTransform {
    transform(items: {key: string, value: any}[] | null, excludedKey: string): any[] {
        return items ? items.filter(item => item.key !== excludedKey) : [];
    }
}
